import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services';
import { CurrentUserModel, StateModel } from '../../../models/account-ledger.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { CheckOutService } from '../../../services/checkout.service';
import { PostcodeList, SuburbList } from '../../../models/account-delivery-address';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../../models/api-response.model';
import { TenantResponse, DickerSelectListItem } from '../../../models/check-out.model';
import { ManageService } from '../../../services/manage.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { first, takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { CustomerService } from '../../../services/customer.service';
import { DDCustomer, UpdateCustomerSubscriptionsModel } from '../../../models/customer.model';

@Component({
  selector: 'app-create-end-user',
  templateUrl: './create-end-user.component.html',
  styleUrls: ['./create-end-user.component.css']
})
export class CreateEndUserComponent implements OnInit, OnDestroy {

  title: string = "New Tenant";
  setFullWindow: boolean = true;
  userFormGroup: FormGroup;
  stateList: string[];
  loadContent: boolean = false;
  programType: string;
  programName: string;
  tenantId: string = '';
  companyCode: string = '';
  selectedPayment: string = '';
  paymentList: DickerSelectListItem[] = [];
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  checkDomain: boolean = false;
  public currentUserModel: CurrentUserModel;
  user_validation_messages: any = {
    "prefixField": [{ class: "domainPrefixValidate", message: "Please enter domain prefix" }],
    "firstNameField": [{ class: "firstNameValidate", message: "Please enter first name" }],
    "lastNameField": [
      { class: "lastNameValidate", message: "Please enter last name" }
    ],
    "emailField": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "companyNameField": [
      { class: "companyNameValidate", message: "Please enter company name" }
    ],
    "addressLine1Field": [
      { class: "addressLine1Validate", message: "Please enter address" }
    ],
    "suburbField": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "stateField": [
      { class: "stateValidate", message: "Please choose state" }
    ],
    "postcodeField": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],
    "phoneField": [
      { class: "phoneValidate", message: "Please enter phone" }
    ],
  };

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private checkOutService: CheckOutService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private manageService: ManageService,
    private commonService: CommonService,
    private customerService: CustomerService,
    private authService: AuthService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    if (this.commonService.isInCustiomerMenu()) {
      $('#levelOne').animate({ scrollLeft: $('#manage-customer').width() + $('#enroll-program').width() + 250 }, 400);
    } else {
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }
  }


  ngOnInit() {
    this.loadContent = false;
    this.companyCode = this.commonService.readCookie("CompanyCode");
    this.checkDomain = false;
    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      this.programType = value.get('programType');
      this.programName = value.get('programName');

      if (this.commonService.isInCustiomerMenu()) {
        this.customerService.currentCustomerWatch.pipe(first()).subscribe((res: DDCustomer) => { 
          this.userFormGroup.get("userGroup.firstNameField").setValue(res?.firstName);
          this.userFormGroup.get("userGroup.lastNameField").setValue(res?.lastName);
          this.userFormGroup.get("userGroup.emailField").setValue(res?.email);
          this.userFormGroup.get("userGroup.companyNameField").setValue(res?.companyName);
          this.userFormGroup.get("userGroup.addressLine1Field").setValue(res?.addressLine1);
          this.userFormGroup.get("userGroup.addressLine2Field").setValue(res?.addressLine2);
          this.userFormGroup.get("userGroup.addressLine3Field").setValue(res?.addressLine3);
          this.userFormGroup.get("userGroup.stateField").setValue(res?.state);
          this.userFormGroup.get("userGroup.suburbField").setValue(res?.suburb);
          this.userFormGroup.get("userGroup.postcodeField").setValue(res?.postcode);
          this.userFormGroup.get("userGroup.phoneField").setValue(res?.phone);
        });
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;
        },
        (error: any) => {
          console.info(error);
        }
      );

    this.shoppingCartService.getState()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: StateModel) => {
          this.stateList = res.states;
        },
        (error: any) => {
          console.error(error);
        },
        () => {
          this.loadContent = true;

        }
      );

  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      prefixField: new FormControl("", Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9]+$'),Validators.maxLength(27)])),
      firstNameField: new FormControl("", Validators.compose([Validators.required])),
      lastNameField: new FormControl("", Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      userNameField: new FormControl({ value: "admin", disabled: true }, Validators.required),
      companyNameField: new FormControl("", Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      phoneField: new FormControl("", Validators.compose([Validators.required]))
    });
  }

  getPaymentMehodList() {
    this.checkOutService.GetDigitalWallet().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: DickerSelectListItem[]) => {
        this.paymentList = value;
      },
        (error: any) => {
          console.info(error);
        });
  }


  selectPaymentMethod() {

    this.checkOutService.UpdateEBillingCustomerNo(this.selectedPayment, this.tenantId, this.programType).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: ApiResponse) => {
        if (value.status === true) {
          this.commonService.implementToast(value.responseMessage, "Success");
        } else {
          this.commonService.implementToast(value.responseMessage, "Error");
        }
      });

  }

  resetPayment() {
    this.selectedPayment = '';
    this.selectPaymentMethod();
  }

  // navigateToDigitalWallet() {
  //   this.router.navigateByUrl('/myAccount/digitalwallet?createNew=true');
  // }

  // navigateToDetailsPage() {
  //   this.router.navigate([`CSPDetailsNew/${this.tenantId}`], { relativeTo: this.activatedRoute.parent });
  // }

  saveEndUser(): void {
    if (this.userFormGroup.get("userGroup").valid) {
      let flag = false;
      if (this.userFormGroup.get('userGroup.postcodeField').value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        this.loadContent = false;
        let inputModel = {} as any;
        inputModel = {
          prefixField:  encodeURIComponent(this.userFormGroup.get('userGroup.prefixField').value),
          firstNameField:  encodeURIComponent(this.userFormGroup.get('userGroup.firstNameField').value),
          lastNameField:  encodeURIComponent(this.userFormGroup.get('userGroup.lastNameField').value),
          emailField:  encodeURIComponent(this.userFormGroup.get('userGroup.emailField').value),
          userNameField: encodeURIComponent(this.userFormGroup.get('userGroup.userNameField').value),
          companyNameField:  encodeURIComponent(this.userFormGroup.get('userGroup.companyNameField').value),
          addressLine1Field: encodeURIComponent(this.userFormGroup.get('userGroup.addressLine1Field').value),
          addressLine2Field: encodeURIComponent(this.userFormGroup.get('userGroup.addressLine2Field').value),
          addressLine3Field: encodeURIComponent(this.userFormGroup.get('userGroup.addressLine3Field').value),
          suburbField: encodeURIComponent(this.userFormGroup.get('userGroup.suburbField').value),
          stateField: encodeURIComponent(this.userFormGroup.get('userGroup.stateField').value),
          postcodeField: encodeURIComponent(this.userFormGroup.get('userGroup.postcodeField').value),
          phoneField: encodeURIComponent(this.userFormGroup.get('userGroup.phoneField').value)
        };

        this.checkOutService
          .CreateCSPTenant(JSON.stringify(inputModel))
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (res: TenantResponse | ApiResponse) => {

              if ((res as ApiResponse)?.status == false) {
                this.commonService.implementToast((res as ApiResponse)?.responseMessage, 'Error')
              } else {
                const tenantCreated = { ...(res as TenantResponse) }
                if (tenantCreated?.result == "Success") {
                  this.tenantId = tenantCreated?.tenantId;
                  this.manageService.monitorAnnuity(tenantCreated);

                  if (this.commonService.isInCustiomerMenu()) {
                    this.customerService.currentCustomerWatch.pipe(first()).subscribe((res: DDCustomer) => { 

                      const input = {
                        customerId: res.id,
                        vendorCustomerId: this.tenantId,
                        programType: 'CSP'
                      } as UpdateCustomerSubscriptionsModel

                      this.customerService.updateCustomerSubscriptions(input)
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe(
                          (res: ApiResponse) => {
                            if (res?.status == true) {
                              setTimeout(() => {
                                this.manageService.backToTenentPage(this.tenantId);
                                this.customerService.refetchCustomerPrograms$.next();
                                // if (this.commonService.isInCustiomerMenu()) {
                                //   $('#levelOne').animate({ scrollLeft: $('#manage-customer').width() + $('#enroll-program').width() + 250 }, 400);
                                // } else {
            
                                //   this.router.navigate([`CSPDetailsNew/${tenantCreated?.tenantId}`], { relativeTo: this.activatedRoute.parent });
                                // }
                              }, 1000);
                            } else {
                              this.commonService.implementToast(res?.responseMessage, "Error");
                            }
                          },
                          (error: any) => {
                            this.commonService.implementToast(error.responseMessage, "Error");
                          },
                          () => {
                            this.loadContent = true;
                          }
                        )
                    });
                   
                  } else {
                    this.commonService.implementToast(tenantCreated?.info, "Success");
                    setTimeout(() => {
                      this.manageService.backToTenentPage(this.tenantId);
                    }, 1000);
                  }

                } else {
                  this.commonService.implementToast(tenantCreated?.info, "Error");
                }
              }
            },
            (error: any) => {
              this.commonService.implementToast(error.responseMessage, "Error");
            },
            () => {
              this.loadContent = true;
            }
          );
      }
    } else {
      this.isNotValidField("userGroup.prefixField", this.user_validation_messages.prefixField);
      this.isNotValidField("userGroup.firstNameField", this.user_validation_messages.firstNameField);
      this.isNotValidField("userGroup.lastNameField", this.user_validation_messages.lastNameField);
      this.isNotValidField("userGroup.emailField", this.user_validation_messages.emailField);
      this.isNotValidField("userGroup.companyNameField", this.user_validation_messages.companyNameField);
      this.isNotValidField("userGroup.addressLine1Field", this.user_validation_messages.addressLine1Field);
      this.isNotValidField("userGroup.suburbField", this.user_validation_messages.suburbField);
      this.isNotValidField("userGroup.stateField", this.user_validation_messages.stateField);
      this.isNotValidField("userGroup.postcodeField", this.user_validation_messages.postcodeField);
      this.isNotValidField("userGroup.phoneField", this.user_validation_messages.phoneField);
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  // startFilterSub(): void {
  //   if (this.userFormGroup.get('userGroup.suburbField').value.length > 2) {
  //     this.checkOutService.getSuburbList(this.userFormGroup.get('userGroup.suburbField').value).subscribe((res: SuburbList[]) => {
  //       this.filteredSub = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  // startFilterPostcode(): void {
  //   if (this.userFormGroup.get('userGroup.postcodeField').value.length > 1) {
  //     this.checkOutService.getPostCodeList(this.userFormGroup.get('userGroup.postcodeField').value).subscribe((res: SuburbList[]) => {
  //       this.filteredPostCode = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }
  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  checkPrefix(): void {
    this.loadContent = false;
    if (this.userFormGroup.get('userGroup.prefixField').valid) {
      this.checkOutService.CheckPrefix(this.userFormGroup.get('userGroup.prefixField').value).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.checkDomain = true;
          // this.commonService.showSuccess(".domainPrefixValidate", res.responseMessage, "right");
          this.commonService.implementToast(res.responseMessage, "Success");
        } else {
          this.checkDomain = false;
          // this.commonService.showError(".domainPrefixValidate", res.responseMessage, "right");
          this.commonService.implementToast(res.responseMessage, "Error");
        }
        this.loadContent = true;
      },
        (error: any) => {
          this.checkDomain = false;
          console.error(error);
          this.loadContent = true;
        });
    } else if (this.userFormGroup.get('userGroup.prefixField').hasError('pattern')) {
      this.checkDomain = false;
      // this.commonService.showError(".domainPrefixValidate", "Domain names can only contain letters and numbers", "right");
      this.commonService.implementToast("Domain names can only contain letters and numbers", "Error");
      this.loadContent = true;
    } else if (this.userFormGroup.get('userGroup.prefixField').hasError('maxlength')) {
      this.checkDomain = false;
      this.commonService.implementToast("Domain names can only contain maximum of 27 letters and numbers", "Error");
      this.loadContent = true;
    } else if (this.userFormGroup.get('userGroup.prefixField').hasError('required')) {
      this.checkDomain = false;
      // this.commonService.showError(".domainPrefixValidate", "Please enter valid company domain", "right");
      this.commonService.implementToast("Please enter valid company domain", "Error");
      this.loadContent = true;
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "userGroup.emailField") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  close() {
    if (this.commonService.isInCustiomerMenu()) {
      this.customerService.backToCustomerEnrollProgramPage();
    } else {
      this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType);
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    }
  }
  omit_nonprintable_char(event: any) {    
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.userFormGroup.get('userGroup.addressLine1Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.userFormGroup.get('userGroup.addressLine2Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.userFormGroup.get('userGroup.addressLine3Field').setValue(event.target.value);
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
